import { ProgramTemplate } from '@libs/src/models/program-template.model';

import isEqual from 'lodash-es/isEqual';

export function areTemplatesTheSame(
  templateA: ProgramTemplate,
  templateB: ProgramTemplate,
) {
  const isSameName = templateA.name === templateB.name;
  const isSameDescription = templateA.description === templateB.description;
  const isSameInviteEmail = isEqual(
    templateA.invitation_email,
    templateB.invitation_email,
  );
  const isSameLabels = isEqual(
    (templateA.labels ?? []).sort(),
    (templateB.labels ?? []).sort(),
  );
  const isTemplateTheSame = areTemplatePhasesTheSame(templateA, templateB);
  return (
    isSameName &&
    isSameDescription &&
    isSameInviteEmail &&
    isSameLabels &&
    isTemplateTheSame
  );
}

export function areTemplatePhasesTheSame(
  templateA: ProgramTemplate,
  templateB: ProgramTemplate,
) {
  if (templateA.phases.length !== templateB.phases.length) {
    return false;
  }
  return templateA.phases.every(
    (phase, index) =>
      phase.name === templateB.phases[index].name &&
      isEqual(phase.email, templateB.phases[index].email) &&
      phase.description === templateB.phases[index].description &&
      phase.type === templateB.phases[index].type,
  );
}
